module.exports = __webpack_public_path__ + "img/img-magic-4-b-04-img-01.998b68d2.png";